import React from 'react';
import PropTypes, { object, string } from 'prop-types';
import cn from 'classnames';

import { Text } from '../../../Elements';

import { findOptionByKey } from '../../helpers/helpers';

import classes from './PlaceholderPart.module.scss';

const PlaceholderPart = props => {
  const { options, selectProps = {} } = props;
  const {
    capitalize = true,
    placeholder,
    renderKey,
    uppercase = false,
    value
  } = selectProps;

  return (
    <Text
      className={cn(
        classes.placeholder,
        capitalize && value?.length > 0 && classes.placeholder_capitalize,
        uppercase && value?.length > 0 && classes.placeholder_uppercase,
        selectProps.value &&
          (value.length > 0 || value.label) &&
          classes.placeholder_select
      )}
    >
      {value && value.length > 0
        ? value
            .map(item => findOptionByKey(item.value, props.options, renderKey))
            .join(', ')
        : value && value.label
        ? findOptionByKey(value.value, options, renderKey)
        : placeholder}
    </Text>
  );
};

PlaceholderPart.propTypes = {
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(object)
  ]),
  selectProps: PropTypes.object
};

export default PlaceholderPart;
